export const selectDueFlashcards = (
  cards = [],
  { nowMs = Date.now(), limit = 5, minDue = 2 } = {}
) => {
  const due = (cards || []).filter(
    (card) => typeof card?.dueAt === "number" && card.dueAt <= nowMs
  );
  due.sort((a, b) => {
    const byDue = (a.dueAt || 0) - (b.dueAt || 0);
    if (byDue !== 0) return byDue;
    return (a.createdAt || 0) - (b.createdAt || 0);
  });
  const sliced = due.slice(0, Math.max(0, limit));
  if (sliced.length < minDue) return [];
  return sliced;
};

export default selectDueFlashcards;
